export class ItemsGroup {
    id: string;
    name: string;
    p_group_id: string;
    items_types: string;
    computation_vat: string;
    taxs: string;
    lewaq: string;
    tax_class: string;
    picture: string;
    row_id: string;
    creation_user: string;
    creation_ip: string;
    created_at: string;
    status: string;

    showDeletedOnly: boolean;

    constructor(id: string, name: string, p_group_id: string, items_types: string, computation_vat: string, status: string, lewaq: string, tax_class: string, picture: string, taxs: string ) {
        this.id = id;
        this.name = name;
        this.tax_class = tax_class;
        this.picture = picture;
        this.taxs = taxs;
        this.items_types = items_types;
        this.computation_vat =  computation_vat;
        this.lewaq = lewaq;
        this.status = status;
        this.p_group_id = p_group_id ;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/itemsGroups/itemsGroups.ts